import Radio from '../src/Radio.vue'

export default Radio
